/**
 * World Cup full-tab welcome overlay — timing and phase count.
 */

import { WELCOME_RULES_PREVIEW_SECTIONS } from './WelcomeRulesPhase.constants';

/**
 * Tab-route welcome must sit above high web z-index chrome (`FloatingCreateButton` 10001,
 * `GlobalSnackbar` 10005, legacy WC header controls that used ~10k) so the full splash paints.
 */
export const WORLD_CUP_WELCOME_ROOT_Z_INDEX = 10050;

export const WORLD_CUP_WELCOME_SCROLL_CONTENT_TOP_EXTRA = 20;

/** Staggered list entrance (rules / points); native driver, bounded block count. */
export const WORLD_CUP_WELCOME_STAGGER = {
  GAP_MS: 42,
  ITEM_DURATION_MS: 300,
  INITIAL_TRANSLATE_Y: 12,
} as const;

/** Phase label+title, each rule preview section, rules CTA */
export const WORLD_CUP_WELCOME_RULES_STAGGER_BLOCK_COUNT =
  1 + WELCOME_RULES_PREVIEW_SECTIONS.length + 1;

/** Phase label+title, scoring timeline, two tip cards, CTA */
export const WORLD_CUP_WELCOME_POINTS_STAGGER_BLOCK_COUNT = 5;

export const WORLD_CUP_WELCOME_ANIM = {
  /** Fade/slide-in for welcome content; shell stays opaque so the tab never flashes through */
  OVERLAY_ENTER_MS: 280,
  OVERLAY_EXIT_MS: 220,
  PHASE_SLIDE_OUT_MS: 160,
  PHASE_SLIDE_IN_MS: 220,
  /** How far (dp) content slides during phase transitions */
  PHASE_SLIDE_DISTANCE: 40,
  /** Base duration (ms) for each background circle pulse cycle */
  CIRCLE_BASE_DURATION_MS: 4000,
  /** Extra ms added per circle index */
  CIRCLE_DURATION_STEP_MS: 1000,
  /** Delay (ms) between starting each circle's animation */
  CIRCLE_DELAY_STEP_MS: 500,
} as const;

/** Splash (0) → Rules (1) → Point system (2); then onEnter → main app */
export const WORLD_CUP_WELCOME_PHASE_LAST = 2 as const;

/** Number of animated background circles on the splash screen */
export const WORLD_CUP_WELCOME_CIRCLE_COUNT = 6 as const;
